import { HttpContextToken } from '@angular/common/http';

/**
 * Marca uma requisição que não deve acender o overlay de carregamento: o ping
 * de sessão e o polling do painel de sessões rodam em segundo plano e não podem
 * piscar a tela inteira a cada ciclo.
 */
export const REQUISICAO_SILENCIOSA = new HttpContextToken<boolean>(() => false);
